export default __webpack_public_path__ + "static/media/logoAsamblea.4d409f89.webp";